type MetricaUser = {
	id: string;
	login: string;
	email: string;
	role: string;
};

type MetricaUserClient = {
	setUserID: (userID: string) => void;
	userParams: (parameters: Record<string, string>) => void;
};

export function syncMetricaUser(user: MetricaUser, metrica: MetricaUserClient) {
	metrica.setUserID(user.id);
	metrica.userParams({
		login: user.login,
		email: user.email,
		role: user.role,
	});
}
